import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

/**
 * Renders a category bucket of items with a "Show more / less" toggle.
 * Always shows `perPage` items initially; expanding reveals the rest.
 *
 *   <CategoryGrid category="Facial" items={facials} perPage={6} renderItem={(s) => <Card s={s} />} />
 */
export function CategoryGrid({ category, items, perPage = 6, renderItem }) {
    const [expanded, setExpanded] = useState(false);
    const visible = expanded ? items : items.slice(0, perPage);
    const hasMore = items.length > perPage;

    return (
        <div data-testid={`category-${category}`}>
            <div className="flex items-end justify-between mb-8 gap-4 flex-wrap">
                <h3 className="font-serif-display text-3xl sm:text-4xl text-[#3D0C1F]">{category}</h3>
                <span className="text-overline">{items.length} {items.length === 1 ? "service" : "services"}</span>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                {visible.map(renderItem)}
            </div>
            {hasMore && (
                <div className="mt-8 flex justify-center">
                    <button
                        type="button"
                        onClick={() => setExpanded((v) => !v)}
                        className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#3D0C1F] hover:text-[#8F622C] border border-[#C29A5B]/40 hover:border-[#C29A5B] px-5 py-3 transition-colors"
                        data-testid={`toggle-category-${category}`}
                    >
                        {expanded ? (
                            <>Show less <ChevronUp size={14} /></>
                        ) : (
                            <>Show all {items.length} <ChevronDown size={14} /></>
                        )}
                    </button>
                </div>
            )}
        </div>
    );
}
